import React, { useCallback, useRef } from 'react';
import styled from '@emotion/styled';
import { ConfigProvider } from 'antd';

import { Content } from 'components/Layout';
import { useMount } from 'ahooks';
import {
  isAddAppShortcutDialogEnable,
  showAddAppShortcutDialog,
} from 'components/NiceMessageDialog/show';

const TargetContainer = styled(Content)`
  flex: 1 0 0;
  overflow-y: auto;
`;
const PopupContainer = styled.div`
  height: 100%;
  position: relative;
  overflow: hidden;
`;

/**
 * 应用内容容器属性
 */
export interface AppContentProps extends React.HTMLAttributes<HTMLElement> {}

/**
 * 应用内容容器
 * @param props 应用内容容器属性
 */
function AppContent(props: AppContentProps) {
  const { children, ...otherProps } = props;
  const targetContainerRef = useRef<HTMLElement>(null!);
  const popupContainerRef = useRef<HTMLDivElement>(null!);
  const getTargetContainer = useCallback(() => {
    return targetContainerRef.current;
  }, []);
  const getPopupContainer = useCallback(() => {
    return popupContainerRef.current;
  }, []);

  useMount(() => {
    if (isAddAppShortcutDialogEnable()) {
      showAddAppShortcutDialog();
    }
  });

  return (
    <ConfigProvider
      getTargetContainer={getTargetContainer}
      getPopupContainer={getPopupContainer}
      autoInsertSpaceInButton={false}
    >
      <TargetContainer {...otherProps} ref={targetContainerRef}>
        <PopupContainer ref={popupContainerRef}>{children}</PopupContainer>
      </TargetContainer>
    </ConfigProvider>
  );
}

export default AppContent;
